import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_140: DocMigration = {
  maxSchemaVersion: "0.0.140",
  description: "Changing room sales dim overrides to pure text overrides",
  apply(json: any) {
    const { rooms } = json;
    for (const roomId in rooms) {
      const room = rooms[roomId];
      if (room?.attributes) {
        if (room.attributes.labelWidthOverride !== undefined) {
          // was in feet
          room.attributes.labelWidthOverride = room.attributes.labelWidthOverride.toString() + "'";
        }
        if (room.attributes.labelHeightOverride !== undefined) {
          // was in feet
          room.attributes.labelHeightOverride = room.attributes.labelHeightOverride.toString() + "'";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_140;
